import { QueryClientProvider, QueryClient } from '@tanstack/react-query';
import { useEffect } from 'react';
import { Navigate, Route, BrowserRouter as Router, Routes, useLocation, useParams } from 'react-router-dom';
import './App.css';
// import CategoryGalleryPage from './Pages/CategoryGalleryPage/CategoryGalleryPage';
import DirectoryPageDark from './Pages/DirectoryPage/DirectoryPageDark';
import PortaitSelectionPage from './Pages/PortraitSelectionPage/PotraitSelectionPage';
// import CommercialPage from './Pages/CommercialPage/CommercialPage';
// import HomePage from './Pages/HomePage/HomePage';
import HomePage from './Pages/HomePage/HomePage';
import PhotographyPage from './Pages/PhotographyPage/PhotographyPage';
import NavBar from './components/NavBar/NavBar';
import PortraitGalleryPage from './Pages/PortraitGalleryPage/PortraitGalleryPage';
import VideoGalleryPage from './Pages/VideoGalleryPage/VideoGalleryPage';
import SelectionPage from './Pages/SelectionPage/SelectionPage';
import "./index.css";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

    return null;
}

function RenderNavBar() {
  const { pathname } = useLocation();
  
  // Calculate directly during render. 
  // This ensures it stays perfectly synced with the current route.
  const shouldShowNavBar = pathname !== "/directory" && pathname !== "/directory-dark" &&  pathname !== "/directory-light";

  if (shouldShowNavBar) {
    return <NavBar />;
  }
  
  return null;
}


const queryClient = new QueryClient()

function GalleryWrapper() {
  // Extract both dynamic parts of the URL path
  const { classification, type } = useParams();

  // Route strictly based on the classification target
  if (type === 'photo') {
    return <PortraitGalleryPage classification={classification} />;
  }

  if (type === 'video') {
    return <VideoGalleryPage classification={classification} />;
  }

  // Redirect if classification doesn't match 'photo' or 'video'
  return <Navigate to="/" replace />;
}

function App() {

  return (
    <QueryClientProvider client={queryClient}>
      <Router>
        <ScrollToTop />
        <RenderNavBar />
        {/* <NavBar /> */}
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/directory" element={<DirectoryPageDark />} />
          {/* Commented out; previous design to work with the classification-based routing */}
          {/* <Route path="/portrait" element={<SelectionPage />} /> */}
          <Route path="/portrait" element={<PortraitGalleryPage classification="portrait" />} />

          <Route path="/commercial" element={<SelectionPage />} />
          {/* <Route path="/portrait/:type" element={<PortraitGalleryPage />} /> */}

          {/* The first parameter accepts 'portrait', 'commercial', etc. */}
          <Route path="/:classification/:type" element={<GalleryWrapper />} />

          {/* <Route path="/commercial" element={<CommercialPage />} /> */}
          {/* <Route path="/gallery/:type/:category" element={<CategoryGalleryPage />} /> */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Router>
    </QueryClientProvider>
  );
}

export default App;
